import axios from 'axios';
import { getCookie } from './cookies';

// axios 1.x's default query-string serializer explodes nested objects into
// bracket-notation params (filters[collections][_in][0]=1...), but the backend's
// custom endpoints expect the pre-1.x behaviour of JSON.stringify-ing any
// non-array object value into a single param (filters={"collections":...}).
// This reproduces axios 0.x's exact legacy `buildURL` serialization so every
// existing GET call keeps sending the wire format the backend already parses.
const encodeParam = val =>
  encodeURIComponent(val)
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']');

const legacyParamsSerializer = params => {
  const parts = [];
  Object.keys(params).forEach(key => {
    let val = params[key];
    if (val === null || typeof val === 'undefined') return;
    if (Array.isArray(val)) {
      key = key + '[]';
    } else {
      val = [val];
    }
    val.forEach(v => {
      if (v instanceof Date) {
        v = v.toISOString();
      } else if (v !== null && typeof v === 'object') {
        v = JSON.stringify(v);
      }
      parts.push(encodeParam(key) + '=' + encodeParam(v));
    });
  });
  return parts.join('&');
};

const axiosApi = (url, method, data, headers = { 'Content-Type': 'application/json' }, reqOptions = {}) => {
  let accessToken = getCookie('ssfToken');
  let options = {
    url,
    method,
    headers: {
      //'Authorization': 'Bearer ' + accessToken,
      ...headers,
    },
    paramsSerializer: legacyParamsSerializer,
    ...reqOptions,
  };

  if (accessToken && accessToken !== undefined && accessToken !== 'undefined') {
    options.headers['Authorization'] = 'Bearer ' + accessToken;
  }

  if (method && method.toLowerCase() === 'get') {
    options.params = data;
  } else {
    options.data = data;
  }

  return axios(options)
    .then(res => {
      let imageType = res?.headers['content-type'];
      if (imageType?.indexOf('image') !== -1 || (imageType === 'application/pdf' && options?.method == 'GET')) {
        let buffer = Buffer.from(res.data).toString('base64');
        let url = 'data:' + imageType + ';base64,' + buffer;
        return url;
      }
      return res?.data;
      if (imageType?.indexOf('image') !== -1) {
        let buffer = Buffer.from(res.data).toString('base64');
        let url = 'data:' + imageType + ';base64,' + buffer;
        return url;
      }

      return res?.data;
    })

    .catch(err => {
      console.log(err);
      //throw new Error(':( something went wrong. please contact support');
      return Promise.reject(err?.response?.data);
    });
};

export default axiosApi;
